import React from 'react';
import Quotes from './Quotes/Quotes';

const App = () => {
  return (
    <>
      <Quotes />
    </>
  );
}

export default App;
